/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { ElementNettoyageDto } from '../models/element-nettoyage-dto';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des éléments de nettoyages
 */
@Injectable({
  providedIn: 'root',
})
export class ElementsNettoyagesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation elementNettoyageGetList
   */
  static readonly ElementNettoyageGetListPath = '/api/elements-nettoyages/list';

  /**
   * Renvoie la liste des éléments de nettoyage.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementNettoyageGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementNettoyageGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<ElementNettoyageDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ElementsNettoyagesService.ElementNettoyageGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ElementNettoyageDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des éléments de nettoyage.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementNettoyageGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementNettoyageGetList(params?: {
  }): Observable<Array<ElementNettoyageDto>> {

    return this.elementNettoyageGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ElementNettoyageDto>>) => r.body as Array<ElementNettoyageDto>)
    );
  }

  /**
   * Path part for operation elementNettoyageLoadList
   */
  static readonly ElementNettoyageLoadListPath = '/api/elements-nettoyages/load-list';

  /**
   * Renvoie la liste des éléments de nettoyage (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementNettoyageLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  elementNettoyageLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, ElementsNettoyagesService.ElementNettoyageLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des éléments de nettoyage (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementNettoyageLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  elementNettoyageLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.elementNettoyageLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation elementNettoyageGet
   */
  static readonly ElementNettoyageGetPath = '/api/elements-nettoyages/{id}';

  /**
   * Renvoie l'élément de nettoyage spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementNettoyageGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementNettoyageGet$Response(params: {

    /**
     * Identifiant dl&#x27;élément de nettoyage
     */
    id: number;
  }): Observable<StrictHttpResponse<ElementNettoyageDto>> {

    const rb = new RequestBuilder(this.rootUrl, ElementsNettoyagesService.ElementNettoyageGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ElementNettoyageDto>;
      })
    );
  }

  /**
   * Renvoie l'élément de nettoyage spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementNettoyageGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementNettoyageGet(params: {

    /**
     * Identifiant dl&#x27;élément de nettoyage
     */
    id: number;
  }): Observable<ElementNettoyageDto> {

    return this.elementNettoyageGet$Response(params).pipe(
      map((r: StrictHttpResponse<ElementNettoyageDto>) => r.body as ElementNettoyageDto)
    );
  }

  /**
   * Path part for operation elementNettoyagePut
   */
  static readonly ElementNettoyagePutPath = '/api/elements-nettoyages/{id}';

  /**
   * Modifie l'élément de nettoyage spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementNettoyagePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  elementNettoyagePut$Response(params: {

    /**
     * Identifiant de l&#x27;élément de nettoyage
     */
    id: number;

    /**
     * Les valeurs dl'élément de nettoyage
     */
    body: ElementNettoyageDto
  }): Observable<StrictHttpResponse<ElementNettoyageDto>> {

    const rb = new RequestBuilder(this.rootUrl, ElementsNettoyagesService.ElementNettoyagePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ElementNettoyageDto>;
      })
    );
  }

  /**
   * Modifie l'élément de nettoyage spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementNettoyagePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  elementNettoyagePut(params: {

    /**
     * Identifiant de l&#x27;élément de nettoyage
     */
    id: number;

    /**
     * Les valeurs dl'élément de nettoyage
     */
    body: ElementNettoyageDto
  }): Observable<ElementNettoyageDto> {

    return this.elementNettoyagePut$Response(params).pipe(
      map((r: StrictHttpResponse<ElementNettoyageDto>) => r.body as ElementNettoyageDto)
    );
  }

  /**
   * Path part for operation elementNettoyageDelete
   */
  static readonly ElementNettoyageDeletePath = '/api/elements-nettoyages/{id}';

  /**
   * Supprime l'élément de nettoyage spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementNettoyageDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementNettoyageDelete$Response(params: {

    /**
     * Identifiant de l&#x27;élément de nettoyage à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, ElementsNettoyagesService.ElementNettoyageDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime l'élément de nettoyage spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementNettoyageDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  elementNettoyageDelete(params: {

    /**
     * Identifiant de l&#x27;élément de nettoyage à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.elementNettoyageDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation elementNettoyagePost
   */
  static readonly ElementNettoyagePostPath = '/api/elements-nettoyages';

  /**
   * Crée l'élément de nettoyage spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `elementNettoyagePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  elementNettoyagePost$Response(params: {
    body: ElementNettoyageDto
  }): Observable<StrictHttpResponse<ElementNettoyageDto>> {

    const rb = new RequestBuilder(this.rootUrl, ElementsNettoyagesService.ElementNettoyagePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ElementNettoyageDto>;
      })
    );
  }

  /**
   * Crée l'élément de nettoyage spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `elementNettoyagePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  elementNettoyagePost(params: {
    body: ElementNettoyageDto
  }): Observable<ElementNettoyageDto> {

    return this.elementNettoyagePost$Response(params).pipe(
      map((r: StrictHttpResponse<ElementNettoyageDto>) => r.body as ElementNettoyageDto)
    );
  }

}
